import { Configuration, configuration } from '@/config';
import clarity from '@/services/clarity';
import logRocket from '@/services/logRocket';
import NewRelicAgent from '@/services/newRelic';

interface NewRelicConfiguration extends Configuration {
  readonly newRelicAppId: string;
  readonly newRelicAccountId: string;
  readonly newRelicTrustKey: string;
  readonly newRelicLicenseKey: string;
  readonly newRelicBeacon: string;
  readonly newRelicErrorBeacon: string;
}

const isNewRelicConfiguration = (
  configuration: Configuration,
): configuration is NewRelicConfiguration => {
  return !!(
    configuration.newRelicAppId &&
    configuration.newRelicAccountId &&
    configuration.newRelicTrustKey &&
    configuration.newRelicLicenseKey &&
    configuration.newRelicBeacon &&
    configuration.newRelicErrorBeacon
  );
};

export const instrumentApplication = (): void => {
  if (configuration.logRocketAppId) {
    console.debug('configuring logrocket');
    logRocket.init(configuration.logRocketAppId);
  }

  if (isNewRelicConfiguration(configuration)) {
    console.debug('configuring newrelic');

    const newRelicConfig = {
      init: {
        session_replay: {
          enabled: true,
          block_selector: '',
          mask_text_selector: '*',
          sampling_rate: 10.0,
          error_sampling_rate: 100.0,
          mask_all_inputs: true,
          collect_fonts: true,
          inline_images: false,
          fix_stylesheets: true,
          preload: false,
          mask_input_options: {},
        },
        distributed_tracing: {
          enabled: true,
        },
        privacy: {
          cookies_enabled: true,
        },
        ajax: {
          deny_list: ['bam.nr-data.net'],
        },
      },
      info: {
        beacon: configuration.newRelicBeacon,
        errorBeacon: configuration.newRelicErrorBeacon,
        licenseKey: configuration.newRelicLicenseKey,
        applicationID: configuration.newRelicAppId,
        sa: 1,
      },
      loader_config: {
        accountID: configuration.newRelicAccountId,
        trustKey: configuration.newRelicTrustKey,
        agentID: configuration.newRelicAppId,
        licenseKey: configuration.newRelicLicenseKey,
        applicationID: configuration.newRelicAppId,
      },
    };

    new NewRelicAgent(newRelicConfig);
  }

  if (configuration.clarityProjectId) {
    console.debug('configuring clarity');
    clarity.init(configuration.clarityProjectId);
  }
};
